"use client";

import React from "react";
import { useCountdown } from "@/lib/utilHooks";
import { bebas } from "@/helpers/bebas";

export default function EventCountdown({
  dateTimeString,
}: {
  dateTimeString: string;
}) {
  const { days, hours, minutes, seconds } = useCountdown(dateTimeString);

  return (
    <>
      <div className="flex justify-center items-center shrink-0 gap-[1rem] lg:gap-[2rem]">
        <div className="flex flex-col justify-center items-center">
          <p className="m-0 font-sans text-black uppercase text-[1.75rem] font-[500]">
            TAGEN
          </p>
          <div className="flex justify-center items-center bg-black/10 rounded-[1rem] w-[9rem] h-[9rem]">
            <h4 className="font-sans text-black text-[6rem] font-[600] leading-[.9em]">
              {days}
            </h4>
          </div>
        </div>

        <div className="flex flex-col opacity-30 gap-[1.75rem] pt-[1.5rem]">
          <div className="bg-black rounded-full w-[.5rem] h-[.5rem]" />

          <div className="bg-black rounded-full w-[.5rem] h-[.5rem]" />
        </div>

        <div>
          <p className="m-0 font-sans text-black uppercase text-[1.75rem] font-[500]">
            STUNDEN
          </p>
          <div className="flex justify-center items-center bg-black/10 rounded-[1rem] w-[9rem] h-[9rem]">
            <h4 className="font-sans text-black text-[6rem] font-[600] leading-[.9em]">
              {hours}
            </h4>
          </div>
        </div>

        <div className="flex flex-col opacity-30 gap-[1.75rem] pt-[1.5rem]">
          <div className="bg-black rounded-full w-[.5rem] h-[.5rem]" />

          <div className="bg-black rounded-full w-[.5rem] h-[.5rem]" />
        </div>

        <div>
          <p className="m-0 font-sans text-black uppercase text-[1.75rem] font-[500]">
            MINUTEN
          </p>
          <div className="flex justify-center items-center bg-black/10 rounded-[1rem] w-[9rem] h-[9rem]">
            <h4 className="font-sans text-black text-[6rem] font-[600] leading-[.9em]">
              {minutes}
            </h4>
          </div>
        </div>

        <div className="flex flex-col opacity-30 gap-[1.75rem] pt-[1.5rem]">
          <div className="bg-black rounded-full w-[.5rem] h-[.5rem]" />

          <div className="bg-black rounded-full w-[.5rem] h-[.5rem]" />
        </div>

        <div>
          <p className="m-0 font-sans text-black uppercase text-[1.75rem] font-[500]">
            SEKUNDEN
          </p>
          <div className="flex justify-center items-center bg-black/10 rounded-[1rem] w-[9rem] h-[9rem]">
            <h4 className="font-sans text-black text-[6rem] font-[600] leading-[.9em]">
              {seconds}
            </h4>
          </div>
        </div>
      </div>
    </>
  );
}
